import AlertIcon from '@assets/icons/alert.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Tooltip } from '@usepepper/ui/atoms/tooltip';
import { Typography } from '@usepepper/ui/atoms/typography';

const ICON_SIZE = 12;
const TOOLTIP_SHADOW_OFFSET = { height: 6, width: 0 };
const TOOLTIP_SHADOW_OPACITY = 0.05;
const TOOLTIP_SHADOW_RADIUS = 12;

interface PriceValidationIconProps {
  message: string;
}

export const PriceValidationIcon: React.FC<PriceValidationIconProps> = ({
  message,
}) => {
  const [styles, theme] = useStyles();

  return (
    <Tooltip
      containerStyle={styles.tooltipContainer}
      placement="top"
      tabIndex={-1}
      trigger={
        <AlertIcon
          height={ICON_SIZE}
          stroke={theme.sk.color.text.error}
          width={ICON_SIZE}
        />
      }
    >
      <Typography color={theme.sk.color.text.ondark} variant="paragraph-sm">
        {message}
      </Typography>
    </Tooltip>
  );
};

const useStyles = createStyles((theme) => ({
  tooltipContainer: {
    backgroundColor: theme.sk.color.bg.toast,
    borderWidth: 0,
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    paddingVertical: theme.sk.spacing.spaceXsmall,
    shadowColor: theme.sk.color.bg.toast,
    shadowOffset: TOOLTIP_SHADOW_OFFSET,
    shadowOpacity: TOOLTIP_SHADOW_OPACITY,
    shadowRadius: TOOLTIP_SHADOW_RADIUS,
  },
}));
